import Vue from 'vue';

import store from '../store';
import App from './components/App.vue';

const id = 'room-listing-app';
const container = document.getElementById(id);

if (container !== null) {
    new Vue({
        el: `#${id}`,
        store,
        render: h => h(App, {
            props: {
                listings: document.getElementById(id).getAttribute('data-listings'),
                theme: document.getElementById(id).getAttribute('data-theme'),
            }
        }),
    })
}